import { fork } from 'redux-saga/effects';

import { RootSagaReturnType } from '~types/saga';
import watchGetSilverPrices from './buyAndSellSilver/getSilverPrices';
import SilverGateway from '~apis/silver';

export default (api: SilverGateway): RootSagaReturnType => {
    function* rootSaga() {
        //buy and sell gold
        yield fork(watchGetSilverPrices, api);
    }

    return {
        rootSaga,
    };
};
